import { render, staticRenderFns } from "./LandingBabyRegistryDE.vue?vue&type=template&id=20a5e009&scoped=true"
import script from "./LandingBabyRegistryDE.vue?vue&type=script&lang=js"
export * from "./LandingBabyRegistryDE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5e009",
  null
  
)

export default component.exports